import commonRoutes from "./routesConfig/commonRoutes";

export const getAuthRoutes = () => {
	let authRoutes = [];

	return authRoutes.concat(commonRoutes);
};
